import { formatDecimalString } from "../../helpers/string-helpers";
import { AvailableUnitExtended } from "../../types/property-types";

export function getSelectedBaseRent(
  selectedUnit: AvailableUnitExtended,
  selectedLeaseTerm: string,
  selectedMoveInDate: string,
) {
  // if no pricing matrix return default price
  if (!selectedUnit?.prices || selectedUnit?.prices?.length === 0) {
    return selectedUnit?.minPrice;
  }

  // find lease term match
  const leaseTermMatches = selectedUnit.prices.filter(
    (price) => price.leaseTerm === selectedLeaseTerm,
  );

  // if no leasing term match return default price
  if (!leaseTermMatches || leaseTermMatches.length === 0) {
    return selectedUnit.minPrice;
  }
  // find matches for both movein date and lease term
  const priceMatches = leaseTermMatches.filter(
    (price) => price.leaseStartsOn === selectedMoveInDate,
  );

  // if we have match(s) for lease terms- return lowest
  if (!priceMatches || priceMatches.length === 0) {
    const leaseTermMatchesCopy = [...leaseTermMatches];
    leaseTermMatchesCopy.sort(
      (a, b) => parseFloat(a.price) - parseFloat(b.price),
    );
    return parseFloat(leaseTermMatchesCopy[0].price);
  }

  // return lowest
  const priceMatchesCopy = [...priceMatches];
  priceMatchesCopy.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
  return parseFloat(priceMatchesCopy[0].price);
}

// export function flattenLeaseData(data: LeaseData[]): FlattenedLeaseData {
//   const flattenedData: FlattenedLeaseData = {};

//   for (const item of data) {
//     const leaseStartDate = item.leaseStartDate;
//     const leasePricing = item.leasePricing;

//     // Initialize the date key if it doesn't exist
//     if (!flattenedData[leaseStartDate]) {
//       flattenedData[leaseStartDate] = {};
//     }

//     // Populate lease months and prices
//     for (const pricing of leasePricing) {
//       const leaseMonths = pricing.leaseMonths;
//       const leasePrice = pricing.leasePrice;
//       flattenedData[leaseStartDate][leaseMonths] = leasePrice;
//     }
//   }
//   return flattenedData;
// }

export function generateLeaseTermDropdownOpts(opts: any) {
  if (!opts) return [];
  return Object.entries(opts).map(([key, value]) => ({
    label: `${key} months (${formatDecimalString(value as string)})`,
    value: key,
  }));
}
